"use client";

import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import Image from "next/image";
import process from '../../assets/images/processing.gif';

export function ProcessingTranscript(props: any) {
  return (
    <>
      <Dialog.Root open={props?.openProcess} onOpenChange={props?.setOpen}>
        <Dialog.Portal>
          {/* Overlay */}
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

          {/* Dialog Content */}
          <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg w-[500px] p-3">
            <div className="rounded-full w-48  mx-auto mt-1 text-center flex items-center justify-center">
              <Image
                className="pt-[30px]"
                src={process}
                alt="qsLogo"
                style={{ width: "100px" }}
              />
            </div>
            <Dialog.Description className="font-semibold mt-4 text-gray-700 text-center text-bold pr-[100px] pb-[50px] pl-[100px]">
              Please wait for sometime as we are processing your session...
            </Dialog.Description>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
